//NOTE: styling can be manipulated from App.scss

function Subheading(props) {
    return <h4 className={props.design}>{props.content}</h4>
}

export default Subheading;